import { useUserStore } from '@/store/modules/user'
/**
 * 初始化打印机
 * 当enable_remote_print为true且printer_token不为空时，启动socket连接并定时刷新打印机列表
 */
export const initPrinter = () => {
  const userStore = useUserStore()
  const config = userStore.getConfig
  console.log('initPrinter', config)

  if (config?.enable_remote_print && config?.printer_token) {
    // 设置打印主机
    startPrinter()

    // 启动定时器，每30秒刷新一次打印机列表
    const timer = setInterval(() => {
      if (!(window as any).hiwebSocket.opened) {
        startPrinter()
        return
      }
      console.log('refreshPrinterList', (window as any).hiwebSocket.opened)
      if ((window as any).hiwebSocket?.refreshPrinterList) {
        ;(window as any).hiwebSocket.refreshPrinterList()
      }
    }, 6000)

    // 返回清理函数，用于组件卸载时清除定时器
    return () => {
      clearInterval(timer)
    }
  }
}

export const startPrinter = () => {
  const userStore = useUserStore()
  const config = userStore.getConfig
  if (!config?.enable_remote_print || !config?.printer_token) {
    closePrinter()
    return
  }
  ;(window as any).hiwebSocket.setHost(import.meta.env.VITE_PRINT_TRANS_HOST, config.printer_token)
}

export const closePrinter = () => {
  if ((window as any).hiwebSocket.opened) {
    ;(window as any).hiwebSocket.stop()
  }
}
